import axios from 'axios';

export const validateBulletin = async (params) => {
  const { data } = await axios.post('/validate-bulletin-member', params);

  return data;
};
